export default class Config {
    static CO_NAME = "Älem Tilsimat";
    static APP_NAME = "Alem Hasap";
    static LEGAL_VERSION = "0.0.1";
    static VERSION = "2.0.9";

    static IS_DEV = false;
    static URL_SERVER = this.IS_DEV ? 'http://127.0.0.1:4000' : window.location.origin;
    static PATH_PREFIX = this.IS_DEV ? "/static" : "/api/static";
    static PATH_DOCUMENTS = "/documents/";
    static PATH_CONTRACT_ATTACHMENTS = "/documents/contract-attachments/";
    static PATH_CONTRACT_PAYMENTS = "/documents/contract-payments/";
    static PATH_EMPLOYEE_DOCUMENTS = "/documents/employee-documents/";
    static PATH_EMPLOYEE_ORDERS = "/documents/employee-orders/";
    static PATH_PASSPORTS = "/documents/passports/";
    static PATH_PARTY_DOCUMENTS = "/documents/party-documents/";
    static PATH_DOC_LETTERS = "/documents/doc-letters/";
    static PATH_TASK_ATTACHMENTS = "/documents/task-attachments/";
    static PATH_ALIMONY_ATTACHMENTS = "/documents/alimony-attachments/";
    static PATH_LEAVE_APP_ATTACHMENTS = "/documents/leave-app-attachments/";
    static PATH_OVERTIME_APP_ATTACHMENTS = "/documents/overtime-app-attachments/";
    static PATH_MILITARY_IDS = "/documents/military-ids/";
    static PATH_CHAT_ATTACHMENTS = "/documents/chat-attachments/";
    static PATH_CHAT_AVATARS = "/images/chat-avatars/";
    static PATH_USER_AVATARS = "/images/user-avatars/";
    static PATH_EMPLOYEE_PHOTOS = "/images/employee-photos/";
    static PATH_COUNTRY_FLAGS = "/images/flags/";
    static PATH_BACKUP_SQL = "/backup/";
    static PATH_PRODUCT_IMAGES = "/images/products/";
    static PATH_ORGANIZATION_LOGO = "/images/organization/";
}